import {
  SYNC_SURVEY_INFO,
  SYNCED_SURVEY_NUM,
  SYNCED_SURVEYS_ADD,
  SYNCED_SURVEYS_UPDATE,
} from "constants/ActionTypes"

const INIT_STATE = {
  num_surveys_pending: 0,
  num_surveys_synced: 0,
  surveys_pending_sync: null,
  survey_synced_detail: [],
}

export default (state = INIT_STATE, action) => {
  switch(action.type) {
    case SYNC_SURVEY_INFO: {
      return{
        ...state,
        num_surveys_pending: action.payload.number,
        surveys_pending_sync: action.payload.surveys_pending_sync
      }
    }
    case SYNCED_SURVEY_NUM: {
      return{
        ...state,
        num_surveys_synced: action.payload.number,
      }
    }
    case SYNCED_SURVEYS_ADD: {
      const newItem = action.payload.survey;
      const newState = state.survey_synced_detail.slice();

      newState.push(newItem);

      return {
        ...state,
        survey_synced_detail: newState
      }
    }
    case SYNCED_SURVEYS_UPDATE: {
      let newState = state.survey_synced_detail.map((item, index) => {
        // Find the item with the matching id
        if(item.sid === action.payload.sid) {
          // Return a new object
          return {
            ...item,  // copy the existing item
            success: action.payload.success  // replace the success
          }
        }
    
        // Leave every other item unchanged
        return item;
      });

      return {
        ...state,
        survey_synced_detail: newState
      }
    }
    default:
      return state;
  }
}